module.exports = __webpack_public_path__ + "media/images/bg/curve-line-cc5ece0c468c9aed7acc86f5ad082b40.svg";